import React, {useEffect, useState} from "react";

import {useHistory, useParams} from "react-router-dom";
import {Alert, Col, Row} from "react-bootstrap";
import CardTable from "../../components/table/CardTable";
import CustomAccordion from "../../components/accordion/CustomAccordion";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import {hasPackagingLinesFullAccess} from "../../helpers/jwt";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {Actions} from "../../../client/Actions";
import {MachineModel} from "./MachineModel";
import AllFormatPartsTableConfig from "./AllFormatPartsTableConfig";
import { useTranslation } from 'react-i18next';


const MachineModelDetailsPage = (props) => {
    let {id} = useParams();

    const { t } = useTranslation();
    const models = useModels();

    const [loader, setLoader] = useState(false);
    const [machineModel, setMachineModel] = useState();
    const [reload, setReload] = useState(false);
    const [machineSelected, setMachineSelected] = useState(false);

    const history = useHistory();

    const loadMachineModel = () => {
        Actions.get("machine-model/" + id, machineModelLoaded)
    };

    const machineModelLoaded = (data) => {
        setMachineModel(data)
    };

    useEffect(() => {
        if (!hasPackagingLinesFullAccess()) {
            history.push("/")
        }
    }, [])

    useEffect(loadMachineModel, [reload]);


    return (
        <>
            <Loader loader={loader}/>
            {machineModel &&
                <CustomContainer
                    title={<>{t("forms.machine_model_format_parts")}</>}
                    parent={
                        <LinkIconButton
                            tooltip={t("common.machine_models")}
                            icon={models.icons["machine-model"]}
                            link={"/machine-models"}
                            props={props}
                        />
                    }
                    subtitle={<>
                        {machineModel.anyPartInstalled && <Alert variant={"warning"}>
                            {t("forms.cannot_edit_model_parts_installed")}
                        </Alert>}
                    </>}

                >

                    <Col>
                        <Row>
                            <Col>
                                <MachineModel
                                    machineModel={machineModel}
                                    setLoader={setLoader}
                                    setReload={setReload}
                                    reload={reload}
                                    editable={hasPackagingLinesFullAccess()}
                                    readOnly={
                                        (machineModel.anyPartInstalled || !hasPackagingLinesFullAccess()) ? true : undefined
                                    }
                                    reloadLine={() => {
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row className={"mt-3"}>
                            <Col>
                                <CustomAccordion
                                    defaultActiveKey={"none"}
                                    items={
                                        [
                                            {
                                                title: t("forms.all_format_parts"),
                                                completable: false,
                                                eventKey: "allFormatParts",
                                                content:
                                                    <Row>
                                                        <CardTable
                                                            withoutHeader={true}
                                                            source={`formatPart/by-machine-model/${machineModel.id}`}
                                                            columns={AllFormatPartsTableConfig}
                                                            width={12}
                                                            setLoader={setLoader}
                                                            setReload={setReload}
                                                            reload={reload}
                                                            striped={false}
                                                            shadow={true}
                                                        />
                                                    </Row>
                                            }
                                        ]
                                    }
                                />
                            </Col>
                        </Row>

                    </Col>
                </CustomContainer>
            }
        </>
    );
};

export default MachineModelDetailsPage;
